import BaseModel from '@/orm/models/BaseModel';

export default class Period extends BaseModel {
  static entity = 'periods';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      duration: this.number(null),
      default: this.boolean(false),
      discountPercent: this.number(null),
    };
  }

  static apiConfig = {
    actions: {
      fetchAll() {
        return this.get('accounting/periods');
      },
    },
  }
}
